import projectService from "./project-service"
import userService from "./user-service"

export default {
  membersRef(projectId) {
    return projectService.projectRef(projectId).child("members")
  },

  memberRef(projectId, email) {
    const escapeEmail = userService.escapeEmail(email)
    return this.membersRef(projectId).child(escapeEmail)
  },

  setRoleToMember(projectId, email, role) {
    return this.memberRef(projectId, email)
      .child("role")
      .set(role)
  },

  setMealsSortByToMember(projectId, email, sortBy) {
    return this.memberRef(projectId, email)
      .child("mealsSortBy")
      .set(sortBy)
  },

  removeMember(projectId, email) {
    return this.setRoleToMember(projectId, email, null)
  },

  onMembersChanged(projectId, callback, errorCallback) {
    this.membersRef(projectId).on(
      "value",
      snapshot => {
        const members = snapshot.val() || {}
        const membersWithEmail = Object.keys(members).reduce(
          (acc, escapedEmail) => {
            const email = userService.unEscapeEmail(escapedEmail)
            acc[email] = members[escapedEmail]
            return acc
          },
          {}
        )
        callback(membersWithEmail)
      },
      errorCallback
    )
  },

  offMembersChanged(projectId) {
    this.membersRef(projectId).off()
  }
}
